import { Dimension } from "../../../components/FileUploadComponent/constants";
export interface INewsContentData {
	title: string;
	shortText: string;
	longText: string;
}

export const defaultNewsContentData: INewsContentData = {
	title: "",
	shortText: "",
	longText: "",
};

export const FileUploadItems = [
	{
		key: "imageUrl",
		label: "Web Haber Detay",
		dimensions: [{ width: 1080, height: 663 }, { width: 1044, height: 601 }] as Dimension[],
		maxFileSize: "2097152",
		extensions: ["jpeg", "jpg", "png"]
	},
	{
		key: "smallImageUrl",
		label: "Web Haber Listesi",
		dimensions: [{ width: 332, height: 332 }] as Dimension[],
		maxFileSize: "2097152",
		extensions: ["jpeg", "jpg", "png"]
	},
	{
		key: "mobileSmallImageUrl",
		label: "Mobil Haber Listesi",
		dimensions: [{ width: 342, height: 200 }] as Dimension[],
		maxFileSize: "2097152",
		extensions: ["jpeg", "jpg", "png"]
	},
	{
		key: "mobileImageUrl",
		label: "Mobil Haber Detay",
		dimensions: [{ width: 768, height: 1024 }] as Dimension[],
		maxFileSize: "2097152",
		extensions: ["jpeg", "jpg", "png"]
	},
];

export const InputStyle = {
	height: "40px",
	width: "100%",
	marginBottom: "10px",
};

export const labelStyle: React.CSSProperties = {
	padding: 0,
	fontWeight: "normal",
	width: "220px",
	fontSize: "15px",
};